<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <b-card class="mb-0">
        <b-link class="brand-logo">

          <h2 class="brand-text text-primary ml-1">
            TRED
          </h2>
        </b-link>
        <validation-observer
            ref="loginForm"
            #default="{invalid}"
        >
          <b-form @submit="sendResendLink" method="post" class="form validate">
            <b-form-group
                label-for="username"
                label="Email"
            >
              <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
              >
                <b-form-input
                    id="username"
                    v-model="username"
                    name="username"
                    :state="errors.length > 0 ? false:null"
                    placeholder="email@gmail.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
              <b-button
                  class="mb-2"
                  variant="primary"
                  type="submit"
                  block
                  :disabled="invalid"
              >
                {{$t('Отправить письмо')}}
              </b-button>
          </b-form>
          <span class="authorize-button">
            {{ $t('Вспомнили пароль?') }}
            <router-link to="/login">{{ $t('Авторизация') }}</router-link>
          </span>
        </validation-observer>

      </b-card>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BLink,
} from 'bootstrap-vue'
import {required, email} from '@validations'
import {createNamespacedHelpers} from 'vuex';
import setPreloader from "@/mixins/setPreloader";

const {mapActions} = createNamespacedHelpers('user');

export default {
  name: 'index',
  components: {
    ValidationProvider, ValidationObserver,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
  },
  mixins: [setPreloader],
  data() {
    return {
      username: '',
      required, email
    };
  },
  methods: {
    ...mapActions(['resetPassword']),
    sendResendLink($event) {
      $event.preventDefault();
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.openPrealoder()
          this.resetPassword(this.username)
              .then(() => {
                this.$bvToast.toast(this.$t('Следуйте инструкциям, высланным на почту'), {
                  title: this.$t('Следуйте инструкциям, высланным на почту'),
                  variant: 'success',
                  solid: true,
                })
                this.$router.push('/login');
              })
              .catch(() => {
                this.$bvToast.toast(this.$t('Пока что невозможно сбросить пароль'), {
                  title: this.$t('Пока что невозможно сбросить пароль'),
                  variant: 'danger',
                  solid: true,
                })
              })
              .finally(() => {
                this.closePreloader()
              });
        }
      })

    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
